export default {
  list: [],
  listInvoices: [],
  graphInvoices: {}
}



// WEBPACK FOOTER //
// ./src/features/import_invoices/store/state.js